//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import Clipboard from 'clipboard'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    // 这里接受参数
    visible: {
      type: Boolean,
      default: false,
    },
    downloadResource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    // 这里存放数据
    return {
      dialogVisible: true,
      checkAll: false,
      checkedCities: [],
      isIndeterminate: true,
      resourceType: {
        pdf: { color: 'rgb(247, 73, 37)', icon: 'icon-pdf' },
        docx: { color: 'rgb(66, 118, 238) ', icon: 'icon-word' },
        doc: { color: 'rgb(66, 118, 238) ', icon: 'icon-word' },
        xlsx: { color: 'rgb(4, 183, 98)', icon: 'icon-xls' },
        csv: { color: '', icon: 'icon-csv' },
        2: { color: 'rgb(179, 127, 235)', icon: 'icon-tupian' },
        3: { color: 'rgb(255, 197, 61)', icon: 'icon-yinpin' },
        4: { color: 'rgb(54, 207, 201)', icon: 'icon-shipin' },
      },
      downLoadLoading: false,
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    handleCheckAllChange(val) {
      console.log(val)
      let ids = []
      ids = this.downloadResource.map((item) => {
        return item.url
      })
      this.checkedCities = val ? ids : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.downloadResource.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.downloadResource.length
    },
    //获取下载包
    getPackages() {
      let checkArr = []
      this.checkedCities.forEach((item) => {
        this.downloadResource.forEach((element) => {
          if (item == element.url) {
            checkArr.push(element)
          }
        })
      })
      this.downloadZip(checkArr, `${document.title || '资源礼包'}`)
    },
    download(url) {
      let a = document.createElement('a')
      a.href = url
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    handleClose() {
      this.$emit('changeVis', false)
    },
    // 点击下载
    downloadZip(checkPackList, name) {
      this.downLoadLoading = true
      var blogTitle = name // 下载后压缩包的命名
      var zip = new JSZip()
      var promises = []
      let cache = {}
      let arrImg = []
      for (let i = 0; i < checkPackList.length; i++) {
        arrImg.push({
          path: checkPackList[i].url, // 文件链接
          name: `${checkPackList[i].resource_name}.${checkPackList[i].format}`, // 文件名称
        })
      }
      for (let item of arrImg) {
        // item.path为文件链接地址
        const promise = this.getImgArrayBuffer(item.path).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.name, data, { binary: true }) // 逐个添加文件
          cache[item.name] = data
        })
        promises.push(promise)
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: 'blob' }).then((content) => {
            // 生成二进制流
            FileSaver.saveAs(content, blogTitle) // 利用file-saver保存文件  自定义文件名
          })
          this.downLoadLoading = false
          this.$emit('changeVis', false)
        })
        .catch(() => {
          alert('文件压缩失败')
        })
    },
    //文件以流的形式获取（参数url为文件链接地址）
    getImgArrayBuffer(url) {
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest()
        xmlhttp.open('GET', url, true)
        xmlhttp.responseType = 'blob'
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response)
          } else {
            reject(this.status)
          }
        }
        xmlhttp.send()
      })
    },
    //复制
    copyCode(val) {
      let clipboard = new Clipboard(val)
      clipboard.on('success', () => {
        this.$zqMessage.success('复制成功')
      })
      clipboard.on('error', () => {
        // 不支持复制
        this.$zqMessage.error('该浏览器不支持复制')
      })
    },
    copyError() {
      this.$zqMessage.error('资源链接不存在')
    },
    //判断安卓还是IOS
    isIos() {
      // if (/android/i.test(navigator.userAgent)) {
      //   return false
      // }
      // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //   return true
      // }
      if (process.browser) {
        let a = /android/i.test(navigator.userAgent)
        return a ? false : true
      }
    },
  },
  // 如果页面有keep-alive缓存功能，这个函数会触发
}
